import { diunaImperiumChapters } from './content';
export const diunaImperiumScoring = diunaImperiumChapters.filter((chapter) => /punkt|scor/i.test(chapter.title));
